export default growl => ({
  verbose: growl.info,
  info: growl.info,
  success: growl.success,
  error: growl.error,
  danger: growl.error,
  warning: growl.warning
});
